// extracted by mini-css-extract-plugin
module.exports = {"sectionHeader":"SectionHeader_sectionHeader__N_SJJ","sectionHeader__title":"SectionHeader_sectionHeader__title__RURDK"};